
import { Component, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { setFocusToInput } from '@/utils/functions';
import { zawaroom } from '@/utils/models';

@Component({ components: { Popup } })
export default class PasswordNeededPopup extends Vue {
  @Prop() private loginFailed!: () => void;
  @Prop() private isVisible!: boolean;

  public isPasswordRequiredPopupDisplayedFirstTime = true;
  private conferencePassword = '';

  public onSendPasswordButtonClick(): void {
    // zawaroom.activeRoom.join(this.conferencePassword);
    // this.hidePasswordNeededPopup();
    // this.isPasswordRequiredPopupDisplayedFirstTime = false;
  }

  private init(): void {
    setFocusToInput(this.$refs.popupInputRef);
  }

  private hidePasswordNeededPopup(): void {
    this.$emit('close');
  }
}
